module.exports = __webpack_public_path__ + "media/alaska/whale-b005cd5a.jpg";